// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.avatar[data-v-785e299e] {\n    height: 20px;\n    width: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
